// @ts-nocheck
import { useTimesheetVerificationRepository } from '../repositories';
// TODO: Submit, approve, reject, and bulk-approve are specialized workflow
// mutations not covered by repository CRUD. Remove compat imports once the
// repository supports custom mutations.
import { useCompatMutation } from './useApolloCompat';
import {
  TIMESHEET_VERIFICATIONS_QUERY,
  SUBMIT_TIMESHEET_MUTATION,
  APPROVE_TIMESHEET_MUTATION,
  REJECT_TIMESHEET_MUTATION,
  BULK_APPROVE_TIMESHEETS_MUTATION,
} from '../graphql/operations';

export function useTimesheetVerifications(variables?: {
  payPeriodId?: string;
  status?: string;
}) {
  const repo = useTimesheetVerificationRepository();
  return repo.useList(variables);
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useSubmitTimesheet() {
  return useCompatMutation(SUBMIT_TIMESHEET_MUTATION, {
    refetchQueries: [{ query: TIMESHEET_VERIFICATIONS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useApproveTimesheet() {
  return useCompatMutation(APPROVE_TIMESHEET_MUTATION, {
    refetchQueries: [{ query: TIMESHEET_VERIFICATIONS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useRejectTimesheet() {
  return useCompatMutation(REJECT_TIMESHEET_MUTATION, {
    refetchQueries: [{ query: TIMESHEET_VERIFICATIONS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
export function useBulkApproveTimesheets() {
  return useCompatMutation(BULK_APPROVE_TIMESHEETS_MUTATION, {
    refetchQueries: [{ query: TIMESHEET_VERIFICATIONS_QUERY }],
  });
}
